import React from 'react';
import { CONST_REPORT_TABS_NEW_COLUMNS } from '../../common/reportsConstants';
import { CommonPage } from '../reports-new';
// import PropTypes from 'prop-types';

export default function ScCustomer() {
  const tabKey = 'SC in Action';
  const columnsProp = CONST_REPORT_TABS_NEW_COLUMNS.filter(item => item.key === tabKey)[0].customer.columns;
  const level = CONST_REPORT_TABS_NEW_COLUMNS.filter(item => item.key === tabKey)[0].customer.level;
  return (
    <div className="sc-in-action-sc-customer">
      <CommonPage tabKey={tabKey} columnsProp={columnsProp} level={level} />
    </div>
  );
};

ScCustomer.propTypes = {};
ScCustomer.defaultProps = {};
